import { useTranslatable } from 'src/hooks/locale/utils'
import AdministratorCoursePlaceholderPage from './AdministratorCoursePlaceholderPage'

export default function AdministratorCourseScoreStatisticsPage(): JSX.Element {
  const t = useTranslatable()
  return <AdministratorCoursePlaceholderPage title={t('subPage:score_statistics')} />
}
